exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collapse[data-v-a758a324] .ant-collapse {\n  border: 1px solid #eef7ff;\n}\n.collapse .collapse-item[data-v-a758a324] {\n  padding: 10px;\n  margin: 4px;\n  cursor: pointer;\n}\n.collapse .collapse-item[data-v-a758a324]:hover {\n  background-color: #eaf5ff;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.collapse .active[data-v-a758a324] {\n  background-color: #eaf5ff;\n  border-radius: 4px;\n}\n", ""]);

// exports
